export default ['$scope', '$timeout', '$routeParams', '$location', function($scope, $timeout, $routeParams, $location) {
  this.endDate = moment();
  this.monthList = [];
  this.unfoldedYears = {};

  this.toggleYear = function(index) {
    return this.unfoldedYears[index] = !this.unfoldedYears[index];
  };

  this.toggleCustom = e =>
    $timeout((() => $scope.pickerActive = true), 0)
  ;

  let getMonths = year => {
    let start = moment(this.startDate);
    let end = moment(this.endDate);
    let startMonth = start.year() === year ? start.month() : 0;
    let endMonth = end.year() === year ? end.month() : 11;

    return (() => {
      let result = [];
      for (let month = startMonth, end1 = endMonth, asc = startMonth <= end1; asc ? month <= end1 : month >= end1; asc ? month++ : month--) {
        result.push({
          label: moment.months(month),
          id: moment.months(month).toLowerCase() + year,
          value: `${moment().month(month).format('MM')}/${year}`
        });
      }
      return result;
    })();
  };

  let buildMonthList = () => {
    let lastMonth;
    this.monthList = __range__(moment(this.endDate).year(), moment(this.startDate).year(), true).map((year) => ({
      year,
      months: getMonths(year).reverse()
    }));

    if (this.date) {
      lastMonth = moment(this.date, 'MM/YYYY').format('MM/YYYY');            
    } else {
      lastMonth = __guard__(this.monthList[0] != null ? this.monthList[0].months[0] : undefined, x => x.value);
    }
    return this.value || (this.value = lastMonth);
  };

  let unfoldSelectedYear = value => {
    if (!value) { return; }
    let currentYear = moment().year();
    let selectedYear = moment(value, ['MM/YYYY', 'DD/MM/YYYY']).year();
    return this.unfoldedYears[currentYear - selectedYear] = true;
  };

  $scope.$watch('ctrl.date', date => { 
    return buildMonthList();
  });

  $scope.$watch('ctrl.value', value => {
    setDate(value);
    return $location.replace().search(_.merge($location.search(), { date: value }));
  });

  this.dateSelected = date => {
    return this.value = moment(date).format('DD/MM/YYYY');
  };

  let useParamsOnLoad = true;
  let unfoldOnLoad = true;
  var setDate = value => { 
    if (!value) { return; }
    if (useParamsOnLoad) {
      let dateParams = $location.search().date;
      this.value = dateParams && moment(dateParams, ['YY/MMMM', 'DD/YY/MMMM']).isValid() ? dateParams : value;
      useParamsOnLoad = false;
    }
    
    if (this.value.length === 7) { // It's end of month
      this.date = moment(this.value, 'MM/YYYY').endOf('month');
    } else {
      this.date = moment(this.value, 'DD/MM/YYYY');
    }
        
    if (unfoldOnLoad) { 
      unfoldSelectedYear(this.value); 
      unfoldOnLoad = false;
    }
  };

  return this;
}
];

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}